import { MastersMetaData } from './mastersmetadata.class';

export class Masters {
    constructor() {}

    setMasterTable = (key: string, response: any) => {
        this[key] = new MastersMetaData(response);
    };

    getTable = (tableId: string): MastersMetaData => {
        for (const key in this) {
            if (key === tableId) {
                return <any>this[key];
            }
        }
        return undefined;
    };

    getTableColumnNames = (tableId: string): String[] => {
        const table = this.getTable(tableId);
        return table.getAllColumnNames() || [];
    };

    setAllTables = (tablesMap: { [key: string]: MastersMetaData }) => {
        Object.keys(tablesMap).forEach(key => {
            this.setMasterTable(key, tablesMap[key]);
        });
    };

    getAllTables = () => {
        const tables = [];
        for (const key in this) {
            if (typeof this[key] !== 'function') {
                tables.push(this[key]);
            }
        }
        return tables;
    };
}
